import {IElement, ITextAttributes} from 'routes/private/Editor/types';

export const flipResolver = ( element: IElement, value: string ):IElement => { 
    element.attributes.flip = value;
    return element;
}